<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      size="1400x650"
      :footer="false">
    <template #header>
      <span>操作日志</span><span class="modal-secondary-title">{{ tplName }}</span>
    </template>
    <template #content>
      <app-base-main
          no-padding
          :table-shadow="false">
        <template #filter-group>
          <app-filter-group
              :reset="false"
              :query="false"
              @query="$gjNoticeQuery">
            <gj-date-picker
                v-model="filter.date"
                :clearable="false"
                type="daterange"
                tooltip="数据时间"
                @input="$gjNoticeQuery"
            ></gj-date-picker>
          </app-filter-group>
        </template>
        <template #table>
          <gj-table
              ref="gjTable"
              :index="false"
              :loading="loading"
              :data="tableData"
              :columns="columns"
              :adapt-height="false"
              :height="480"
              :pagination="pagination"
              @page-change="$gjNoticeQuery">
            <template v-slot:notifyType="{ row }">
              <gj-tooltip v-if="row.notifyType !== 2" :content="row.notifyUserStr" :text-line="1">
                {{row.notifyType|optionText(AdStrategyEnum.resultOption)}}{{' - '+row.notifyUserStr}}
              </gj-tooltip>
              <template v-else>
                {{row.notifyType|optionText(AdStrategyEnum.resultOption)}}
              </template>
            </template>
            <template v-slot:bidSet="{ row }">
              <app-bid-strategy-set-info
                  :item="row"
              ></app-bid-strategy-set-info>
            </template>
            <template v-slot:budgetSet="{ row }">
              <app-budget-strategy-set-info
                  :item="row"
              ></app-budget-strategy-set-info>
            </template>
            <template v-slot:placementSet="{ row }">
              <app-placement-strategy-set-info
                  :item="row"
              ></app-placement-strategy-set-info>
            </template>
            <template v-slot:validDate="{row}">
              <template v-if="row.startDate">
                {{row.startDate | defaultShow('', '~', '')}}{{row.endDate}}
              </template>
              <template v-else>-</template>
            </template>
          </gj-table>
        </template>
      </app-base-main>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn, queryMixin} from "../../../../../../../minxins";
  import {getAdsAdjustStrategyTplLogPage} from "../../../../../../../api/ad";
  import {convertToDate} from "../../../../../../../utils/date.util";
  import {isMeaningful} from "../../../../../../../utils/common";
  import AppBidStrategySetInfo from "../../components/bid-strategy-set-info";
  import AppBudgetStrategySetInfo from "../../components/budget-strategy-set-info";
  import AppPlacementStrategySetInfo from "../../components/placement-strategy-set-info";
  import {subDays} from 'date-fns';
  import {AdStrategyEnum} from '../../../common/enum';

  export default {
    name: "app-strategy-tpl-log-modal",
    components: {AppPlacementStrategySetInfo, AppBudgetStrategySetInfo, AppBidStrategySetInfo},
    mixins: [modalMixIn, queryMixin],
    props: {
      tplId: {
        default: null
      },
      tplName: {
        default: ''
      }
    },
    data() {
      return {
        AdStrategyEnum,
        tableData: [],
        columns: [
          {id: 'templateName', header: '模板名称', field: 'templateName', minWidth: '120px'},
          {id: 'templateType', header: '是否共享', field: 'option:templateType',
            options: [
              {id: 0, text: '是'},
              {id: 1, text: '否'},
            ], width: '70px'},
          {id: 'notifyType', header: '执行通知', field: 'slot:notifyType', width: '200px'},
          {id: 'bidSet', header: '竞价设置', field: 'slot:bidSet', minWidth: '200px'},
          {id: 'budgetSet', header: '每日预算设置', field: 'slot:budgetSet', minWidth: '200px'},
          {id: 'placementSet', header: '广告位设置', field: 'slot:placementSet', minWidth: '200px'},
          {id: 'validDate', header: '起止时间', field: 'slot:validDate', width: '115px'},
          {id: 'updateUserName', header: '操作用户', field: 'updateUserName', minWidth: '80px'},
          {id: 'updateDate', header: '操作时间', field: 'updateDate', width: '160px'},
        ],
        filter: {
          date: [subDays(new Date(), 14), new Date()],
        }
      }
    },
    created() {
      this.sort.prop = 'id';
    },
    methods: {
      $gjQuery() {
        // 构造查询参数
        const params = {
          model: {
            templateId: this.tplId,
            startDate: isMeaningful(this.filter.date) ? convertToDate(this.filter.date[0]) : null,
            endDate: isMeaningful(this.filter.date) ? convertToDate(this.filter.date[1]) : null,
          },
          ...this.queryPagination,
          ...this.querySort
        };
        // 查询
        this.loading = true;
        getAdsAdjustStrategyTplLogPage(params)
          .then((data) => {
            this.tableData = (data.records || []);
            this.pagination = this.getPagination(data);
          })
          .complete(() => this.loading = false);
      }
    }
  }
</script>

<style scoped>

</style>

